










import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

@Component({
  computed: {
    ...mapGetters({
      grids: 'grid/getGrids',
      gameRunning: 'game/getGameState'
    })
  },
  methods: {
    ...mapActions('grid', ['setEmptyGrid', 'revealGrid', 'checkWin']),
    ...mapActions('game', ['startGame'])
  }
})
export default class Grid extends Vue {
  setEmptyGrid!: () => void;
  startGame!: () => void;
  revealGrid!: ({ col, row}: { col: number; row: number}) => void;
  gameRunning!: boolean;

  initRevealGrid(col: number, row: number): void {
    this.revealGrid({col, row});
    if (!this.gameRunning) {
      this.startGame();
    }
  }

  created() {
    this.setEmptyGrid();
  }

}
